var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "PortalWidget",
    {
      staticClass: "numbers-list",
      attrs: {
        widget: {
          title: _vm.widgetTitle,
          iconClass: "typcn typcn-phone"
        }
      },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              !_vm.vm.showSpecificRecordDetails
                ? _c(
                    "div",
                    { staticClass: "header-extra" },
                    [
                      _c("ColumnToggle", {
                        attrs: {
                          "table-name": "numbers",
                          "user-settings": _vm.userSettings,
                          "settings-status": _vm.getUserSettingsStatus,
                          "column-settings": _vm.vm.columnSettings
                        },
                        on: {
                          onChange: function($event) {
                            return _vm.vm.syncColumns()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("button", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "NUMBER_POOLS_EXPORT_BUTTON_CSV",
                            expression: "'NUMBER_POOLS_EXPORT_BUTTON_CSV'"
                          }
                        ],
                        staticClass: "btn btn-sm widget-header-button",
                        on: {
                          click: function($event) {
                            return _vm.vm.exportNumbersCSV()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("SearchableDropdown", {
                        staticClass:
                          "m-r-10 btn-xl pull-right widget-header-dropdown",
                        attrs: {
                          value: _vm.$t(_vm.vm.selectedOptionDropdown),
                          searchable: false,
                          config: _vm.filterConfig
                        },
                        on: {
                          change: function($event) {
                            return _vm.vm.onFilterChange($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filters.name.value,
                            expression: "filters.name.value"
                          }
                        ],
                        staticClass:
                          "form-control input-md widget-header-input m-r-10",
                        attrs: {
                          type: "search",
                          placeholder: _vm.$t("SEARCH")
                        },
                        domProps: { value: _vm.filters.name.value },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filters.name,
                              "value",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.vm.isLoading
        ? _c(
            "div",
            { staticClass: "m-t-10 m-b-15" },
            [
              _vm.vm.hasNumberPermissionAccess &&
              !_vm.vm.showSpecificRecordDetails &&
              !_vm.vm.isAffiliateManager
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-success btn-sm",
                      attrs: { type: "button", disabled: _vm.vm.isCreateMode },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.vm.showForm(null)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "typcn typcn-plus" }),
                      _vm._v(" "),
                      _c("span", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "NUMBER_CREATE_BUTTON",
                            expression: "'NUMBER_CREATE_BUTTON'"
                          }
                        ]
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.vm.showSpecificRecordDetails
                ? _c(
                    "a",
                    {
                      staticClass: "btn btn-default btn-sm",
                      attrs: { href: _vm.getHref("dashboard.numbers") }
                    },
                    [
                      _c("i", { staticClass: "fa fa-arrow-left" }),
                      _vm._v(" "),
                      _c("span", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "NUMBERS_SHOW_ALL",
                            expression: "'NUMBERS_SHOW_ALL'"
                          }
                        ]
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.vm.isAdmin
                ? _c("NumbersOrdersButton", { staticClass: "right" })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid_table_holder" },
        [
          _c(
            "v-table",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.displayNumbers.length || _vm.vm.isCreateMode,
                  expression: "displayNumbers.length || vm.isCreateMode"
                }
              ],
              staticClass: "table_beauty",
              attrs: {
                data: _vm.displayNumbers,
                "current-page": _vm.currentPage,
                "page-size": 20,
                filters: _vm.filters,
                "hide-sort-icons": true,
                cellpadding: "0",
                cellspacing: "0"
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function($event) {
                  _vm.currentPage = $event
                },
                totalPagesChanged: function($event) {
                  _vm.totalPages = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ displayData }) {
                    return _c(
                      "tbody",
                      {},
                      [
                        !_vm.vm.isCreateMode && !displayData.length
                          ? _c("tr", [
                              _c("td", {
                                directives: [
                                  {
                                    name: "t",
                                    rawName: "v-t",
                                    value: "NUMBERS_HEADER_NONE",
                                    expression: "'NUMBERS_HEADER_NONE'"
                                  }
                                ],
                                attrs: { colspan: "100" }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.vm.isCreateMode
                          ? _c(
                              "tr",
                              { staticClass: "row-inline-new-form slide-down" },
                              [
                                _c(
                                  "td",
                                  { attrs: { colspan: "100" } },
                                  [
                                    _c("ManageNumbers", {
                                      attrs: { "form-name": "create" },
                                      on: {
                                        cancel: function($event) {
                                          return _vm.vm.hideForm()
                                        },
                                        submit: function($event) {
                                          return _vm.vm.onSave()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(displayData, function(number) {
                          return [
                            _c(
                              "tr",
                              {
                                key: "data_" + number.id,
                                staticClass: "border_bottom height-42"
                              },
                              [
                                _vm.isMobileView
                                  ? _c("td", [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn btn-list-function btn-expand-actions",
                                          on: {
                                            click: function($event) {
                                              return _vm.vm.showForm(number)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-ellipsis-v"
                                          })
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.activeColumns, function(col) {
                                  return _c(
                                    "td",
                                    {
                                      key: col,
                                      attrs: {
                                        align:
                                          _vm.vm.columnSettings[col].rowAlign
                                      }
                                    },
                                    [
                                      col === "allocationDT"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.utcToLocal(
                                                    number.allocationDT
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ])
                                        : col === "nextChargeDT"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.utcToLocal(
                                                    number.nextChargeDT
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ])
                                        : col === "country"
                                        ? _c(
                                            "span",
                                            [
                                              _c("CountryFlag", {
                                                attrs: {
                                                  "country-code":
                                                    number.countryCode
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : col === "phoneNumber"
                                        ? _c(
                                            "span",
                                            { staticClass: "clickable" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: _vm.getHref(
                                                      "dashboard.numbers.edit",
                                                      { numberId: number.id }
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.vm.showForm(
                                                        number
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        number.phoneNumber
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              number.isInternalOnly
                                                ? _c("i", {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName:
                                                          "v-tooltip.right.hover",
                                                        value: _vm.$t(
                                                          "INTERNAL_USE_NUMBER"
                                                        ),
                                                        expression:
                                                          "$t('INTERNAL_USE_NUMBER')",
                                                        modifiers: {
                                                          right: true,
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "fa fa-lock p-l-5"
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        : col === "name"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(number.name) +
                                                "\n              "
                                            )
                                          ])
                                        : col === "displayNumber"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(number.displayNumber) +
                                                "\n              "
                                            )
                                          ])
                                        : col === "status"
                                        ? _c("span", [
                                            _c("span", {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName:
                                                    "v-tooltip.right.hover",
                                                  value: _vm.$t(
                                                    number.enabled &&
                                                      !_vm.vm
                                                        .currentAccountIsPaused
                                                      ? "ENABLED"
                                                      : "PAUSED"
                                                  ),
                                                  expression:
                                                    "$t(number.enabled && !vm.currentAccountIsPaused ? 'ENABLED' : 'PAUSED')",
                                                  modifiers: {
                                                    right: true,
                                                    hover: true
                                                  }
                                                }
                                              ],
                                              staticClass: "color-dot",
                                              class: {
                                                yellow_status:
                                                  !number.enabled ||
                                                  _vm.vm.currentAccountIsPaused,
                                                green_status:
                                                  number.enabled &&
                                                  !_vm.vm.currentAccountIsPaused
                                              }
                                            })
                                          ])
                                        : col === "campaignId"
                                        ? _c(
                                            "span",
                                            [
                                              _vm.vm.isAdmin &&
                                              number.campaignName &&
                                              !number.isCampaignComplete
                                                ? _c("LinkedName", {
                                                    attrs: {
                                                      href: _vm.getHref(
                                                        "dashboard.campaign-wizard",
                                                        {
                                                          campaignId:
                                                            number.campaignId
                                                        }
                                                      ),
                                                      title: number.campaignName
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              number.campaignName &&
                                              number.isCampaignComplete
                                                ? _c("LinkedName", {
                                                    attrs: {
                                                      href: _vm.getHref(
                                                        "dashboard.campaign",
                                                        {
                                                          campaignId:
                                                            number.campaignId
                                                        }
                                                      ),
                                                      title: number.campaignName
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.vm.isAdmin &&
                                              number.campaignName &&
                                              !number.isCampaignComplete
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          number.campaignName
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !number.campaignName
                                                ? _c("span", [
                                                    _c("i", {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName:
                                                            "v-tooltip.right.hover",
                                                          value: _vm.$t(
                                                            "NUMBERS_LINK_CAMPAIGN_TT"
                                                          ),
                                                          expression:
                                                            "$t('NUMBERS_LINK_CAMPAIGN_TT')",
                                                          modifiers: {
                                                            right: true,
                                                            hover: true
                                                          }
                                                        }
                                                      ],
                                                      staticClass:
                                                        "false typcn typcn-minus"
                                                    })
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : col === "numberPoolId"
                                        ? _c("span", [
                                            number.numberPoolId
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        number.numberPoolName
                                                      ) +
                                                      "\n                "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !number.numberPoolId
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-function",
                                                    class: {
                                                      "opacity-50":
                                                        number.campaignId ||
                                                        number.publisherId
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        number.campaignId ||
                                                        number.publisherId
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.vm.selectNumberPoolModal(
                                                          number
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName:
                                                            "v-tooltip.right.hover",
                                                          value: _vm.$t(
                                                            number.campaignId ||
                                                              number.publisherId
                                                              ? "NUMBERS_LINK_POOL_TT"
                                                              : "NUMBERS_ASSIGN_NP_TT"
                                                          ),
                                                          expression:
                                                            "$t((number.campaignId || number.publisherId) ? 'NUMBERS_LINK_POOL_TT' : 'NUMBERS_ASSIGN_NP_TT')",
                                                          modifiers: {
                                                            right: true,
                                                            hover: true
                                                          }
                                                        }
                                                      ],
                                                      staticClass:
                                                        "fa fa-fw fa-plus"
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                        : col === "offer"
                                        ? _c("span", [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName:
                                                      "v-tooltip.right.hover",
                                                    value: _vm.$t(
                                                      "NUMBER_OFFER_LINK"
                                                    ),
                                                    expression:
                                                      "$t('NUMBER_OFFER_LINK')",
                                                    modifiers: {
                                                      right: true,
                                                      hover: true
                                                    }
                                                  }
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(number.offerName) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          ])
                                        : col === "affiliate"
                                        ? _c("span", [
                                            _c("span", [
                                              number.publisherId
                                                ? _c(
                                                    "span",
                                                    [
                                                      !_vm.vm.isAdmin
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  number.publisherName
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.vm.isAdmin
                                                        ? _c(
                                                            "LinkedName",
                                                            {
                                                              attrs: {
                                                                href: _vm.getHref(
                                                                  "dashboard.affiliate.edit",
                                                                  {
                                                                    affiliateId:
                                                                      number.publisherId,
                                                                    name:
                                                                      number.publisherName
                                                                  }
                                                                ),
                                                                title:
                                                                  number.publisherName
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "m-r-5",
                                                                  attrs: {
                                                                    href: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.vm.removeAffiliate(
                                                                        number
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "tooltip",
                                                                        rawName:
                                                                          "v-tooltip.right.hover",
                                                                        value: _vm.$t(
                                                                          "UNASSIGN_PUBLISHER_FROM_NUMBER"
                                                                        ),
                                                                        expression:
                                                                          "$t('UNASSIGN_PUBLISHER_FROM_NUMBER')",
                                                                        modifiers: {
                                                                          right: true,
                                                                          hover: true
                                                                        }
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "fa fa-fw fa-times",
                                                                    attrs: {
                                                                      "tooltip-class":
                                                                        "tooltip-white",
                                                                      "tooltip-append-to-body":
                                                                        "true"
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !number.publisherId
                                                ? _c("span", [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "btn btn-function",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.vm.selectAffiliateModal(
                                                              number
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip.right.hover",
                                                              value: _vm.$t(
                                                                "NUMBERS_ASSIGN_TT"
                                                              ),
                                                              expression:
                                                                "$t('NUMBERS_ASSIGN_TT')",
                                                              modifiers: {
                                                                right: true,
                                                                hover: true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "fa fa-fw fa-plus"
                                                        })
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e()
                                            ])
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                !_vm.isMobileView
                                  ? _c(
                                      "td",
                                      [
                                        _c("NumberActions", {
                                          attrs: { number: number }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.isMobileView &&
                            _vm.vm.getIsEditingNumberId(number.id)
                              ? _c(
                                  "tr",
                                  {
                                    key: "actions_" + number.id,
                                    staticClass:
                                      "mobile-actions ng-animate-disabled slide-right"
                                  },
                                  [
                                    _c(
                                      "td",
                                      { attrs: { colspan: "10" } },
                                      [
                                        _c("NumberActions", {
                                          attrs: { number: number }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.vm.getIsEditingNumberId(number.id)
                              ? _c(
                                  "tr",
                                  {
                                    key: "edit_" + number.id,
                                    staticClass:
                                      "slide-down row-inline-new-form",
                                    attrs: {
                                      "ng-class-odd": "'bg-row-odd'",
                                      "ng-class-even": "'bg-row-even'"
                                    }
                                  },
                                  [
                                    _c(
                                      "td",
                                      { attrs: { colspan: "100" } },
                                      [
                                        _c("ManageNumbers", {
                                          staticClass: "p-t-20",
                                          attrs: {
                                            "form-name": "edit",
                                            "current-number": number
                                          },
                                          on: {
                                            cancel: function($event) {
                                              return _vm.vm.hideForm()
                                            },
                                            submit: function($event) {
                                              return _vm.vm.onSave()
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  }
                }
              ])
            },
            [
              _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                _c(
                  "tr",
                  [
                    _vm.isMobileView ? _c("th") : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.activeColumns, function(col) {
                      return _c("v-th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: _vm.vm.columnSettings[col].displayName,
                            expression: "vm.columnSettings[col].displayName"
                          }
                        ],
                        key: col,
                        class: _vm.vm.columnSettings[col].class,
                        attrs: {
                          "default-sort":
                            _vm.vm.columnSettings[col].defaultSort,
                          "sort-key": _vm.vm.columnSettings[col].name
                        }
                      })
                    }),
                    _vm._v(" "),
                    !_vm.isMobileView
                      ? _c("th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "NUMBERS_ACTIONS",
                              expression: "'NUMBERS_ACTIONS'"
                            }
                          ]
                        })
                      : _vm._e()
                  ],
                  2
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "pagination-min" }, [
            _c(
              "div",
              { staticClass: "text-center p-7" },
              [
                _c("smart-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "total-pages": _vm.totalPages,
                    "max-page-links": 20
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.vm.isLoading
        ? _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.loadingTitle))])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.vm.modal
        ? [
            _vm.vm.modal.type === "confirm-pause"
              ? _c("NumberPauseModal", {
                  attrs: { number: _vm.vm.modal.number },
                  on: {
                    close: function($event) {
                      return _vm.vm.cancelModal()
                    },
                    confirm: function($event) {
                      return _vm.vm.setNumberStatus(null, false)
                    }
                  }
                })
              : _vm.vm.modal.type === "confirm-delete"
              ? _c("NumberDeleteModal", {
                  attrs: {
                    number: _vm.vm.modal.number,
                    "number-references": _vm.vm.numberReferences,
                    "is-loading": _vm.vm.numberReferencesState === "loading",
                    "on-confirm": _vm.vm.modal.onSubmit
                  },
                  on: {
                    close: function($event) {
                      return _vm.vm.cancelModal()
                    }
                  }
                })
              : _vm.vm.modal.type === "select-pool"
              ? _c("NumberSelectPoolModal", {
                  attrs: {
                    "selected-number": _vm.vm.modal.number,
                    "pools-list": _vm.vm.numberPools,
                    "on-submit": args =>
                      _vm.vm.attachNumberPool(args.poolId, args.numberId)
                  },
                  on: {
                    cancel: function($event) {
                      return _vm.vm.cancelModal()
                    }
                  }
                })
              : _vm.vm.modal.type === "select-affiliate"
              ? _c("NumberSelectAffiliateModal", {
                  attrs: {
                    "selected-number": _vm.vm.modal.number,
                    "affiliates-list": _vm.vm.affiliates,
                    "on-submit": args =>
                      _vm.vm.attachAffiliate(args.affiliateId, args.numberId)
                  },
                  on: {
                    cancel: function($event) {
                      return _vm.vm.cancelModal()
                    }
                  }
                })
              : _vm.vm.modal.type === "confirm-remove-affiliate"
              ? _c(
                  "ConfirmationModal",
                  {
                    attrs: {
                      entity: _vm.vm.modal.number,
                      title: _vm.$t("NUMBER_REMOVE_AFFILIATE"),
                      "cancel-button-text": _vm.$t("CANCEL"),
                      "confirm-action-text": _vm.$t(
                        "NUMBER_REMOVE_AFFILIATE_CONFIRM"
                      ),
                      "on-confirm": _vm.vm.modal.onSubmit
                    },
                    on: {
                      close: function($event) {
                        return _vm.vm.cancelModal()
                      }
                    }
                  },
                  [
                    _c("p", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "NUMBER_REMOVE_AFFILIATE_TEXT",
                          expression: "'NUMBER_REMOVE_AFFILIATE_TEXT'"
                        }
                      ]
                    })
                  ]
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }